export enum FIELD_NAME {
  debitorId = 'debitorId',
  invoiceId = 'invoiceId',
}

export type FormValuesType = {
  [FIELD_NAME.debitorId]: string;
  [FIELD_NAME.invoiceId]: string;
}

